import {
  AlertTriangle,
  ArrowRight,
  ArrowUp,
  Box,
  Check,
  ChevronDown,
  ChevronDownCircle,
  ChevronLeft,
  ChevronLeftCircle,
  ChevronRight,
  ChevronRightCircle,
  ChevronUp,
  ChevronUpCircle,
  Copy,
  CreditCard,
  File,
  FileText,
  Fullscreen,
  Globe,
  HelpCircle,
  Home,
  Image,
  Laptop,
  Linkedin,
  Loader2,
  type LucideIcon,
  type LucideProps,
  MapPin,
  Menu,
  Moon,
  MoreVertical,
  Paperclip,
  Pen,
  Pencil,
  Pizza,
  Play,
  Plus,
  Redo,
  Settings,
  SunMedium,
  ThumbsDown,
  ThumbsUp,
  Trash,
  Twitter,
  Undo,
  Upload,
  User,
  X,
} from 'lucide-react'

export type Icon = LucideIcon

export const Icons = {
  sidebarLeftIcon: ({ size = 16 }: { size?: number }) => (
    <svg
      height={size}
      strokeLinejoin="round"
      viewBox="0 0 16 16"
      width={size}
      style={{ color: 'currentcolor' }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.245 2.5H14.5V12.5C14.5 13.0523 14.0523 13.5 13.5 13.5H6.245V2.5ZM4.995 2.5H1.5V12.5C1.5 13.0523 1.94772 13.5 2.5 13.5H4.995V2.5ZM0 1H1.5H14.5H16V2.5V12.5C16 13.8807 14.8807 15 13.5 15H2.5C1.11929 15 0 13.8807 0 12.5V2.5V1Z"
        fill="currentColor"
      />
    </svg>
  ),
  plus: Plus,
  logo: ({ ...props }: LucideProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="500"
      zoomAndPan="magnify"
      viewBox="0 0 375 374.999991"
      height="500"
      preserveAspectRatio="xMidYMid meet"
      version="1.0"
      fill="currentColor"
      {...props}
    >
      <defs>
        <clipPath id="d07a250479">
          <path
            d="M 114 8 L 359 8 L 359 367.460938 L 114 367.460938 Z M 114 8 "
            clipRule="nonzero"
          />
        </clipPath>
      </defs>
      <g clipPath="url(#d07a250479)">
        <path
          d="M 183.332031 85.40625 C 184.453125 86.527344 185.855469 87.089844 187.257812 87.089844 L 220.917969 87.089844 C 222.320312 87.089844 223.722656 86.527344 224.84375 85.40625 L 234.101562 76.152344 C 236.90625 77.554688 239.992188 78.398438 243.359375 78.398438 C 254.296875 78.398438 262.992188 69.707031 262.992188 58.769531 C 262.992188 47.835938 254.296875 39.144531 243.359375 39.144531 C 232.417969 39.144531 223.722656 47.835938 223.722656 58.769531 C 223.722656 62.136719 224.566406 65.21875 225.96875 68.023438 L 218.675781 75.875 L 189.503906 75.875 L 170.429688 56.808594 L 170.429688 19.796875 L 186.699219 19.796875 C 187.257812 19.796875 187.820312 20.078125 188.378906 19.796875 C 238.308594 17.835938 289.640625 40.546875 314.605469 87.089844 L 295.808594 87.089844 C 293.285156 78.957031 285.992188 73.070312 277.015625 73.070312 C 266.078125 73.070312 257.382812 81.761719 257.382812 92.695312 C 257.382812 101.667969 263.273438 108.957031 271.40625 111.480469 L 271.40625 162.789062 L 229.332031 162.789062 C 226.246094 162.789062 223.722656 165.3125 223.722656 168.398438 L 223.722656 199.238281 L 212.503906 199.238281 L 212.503906 165.59375 C 212.503906 163.910156 211.660156 162.507812 210.539062 161.386719 L 192.867188 146.246094 L 192.867188 109.519531 L 215.867188 109.519531 L 223.441406 117.089844 C 222.039062 119.890625 221.199219 122.976562 221.199219 126.339844 C 221.199219 137.277344 229.894531 145.96875 240.832031 145.96875 C 251.773438 145.96875 260.46875 137.277344 260.46875 126.339844 C 260.46875 115.40625 251.773438 106.714844 240.832031 106.714844 C 237.46875 106.714844 234.382812 107.554688 231.578125 108.957031 L 222.320312 99.707031 C 220.917969 98.863281 219.515625 98.304688 218.113281 98.304688 L 187.257812 98.304688 C 184.171875 98.304688 181.648438 100.828125 181.648438 103.910156 L 181.648438 148.769531 C 181.648438 150.453125 182.488281 151.855469 183.613281 152.976562 L 201.285156 168.117188 L 201.285156 199.238281 L 178.84375 199.238281 C 177.441406 199.238281 176.039062 199.796875 174.917969 200.921875 L 130.039062 245.78125 C 128.914062 246.902344 128.355469 248.304688 128.355469 249.707031 L 128.355469 295.40625 C 120.21875 297.929688 114.328125 305.21875 114.328125 314.191406 C 114.328125 325.125 123.023438 333.816406 133.964844 333.816406 C 144.902344 333.816406 153.597656 325.125 153.597656 314.191406 C 153.597656 305.21875 147.707031 297.929688 139.574219 295.40625 L 139.574219 251.949219 L 181.085938 210.453125 L 282.628906 210.453125 C 284.871094 210.453125 286.835938 209.332031 287.675781 207.367188 L 304.503906 173.722656 C 304.785156 172.882812 305.066406 172.042969 305.066406 171.199219 L 305.066406 151.574219 L 329.75 151.574219 L 329.75 174.566406 L 322.457031 190.546875 C 321.898438 191.949219 321.898438 193.351562 322.175781 194.753906 L 346.859375 260.640625 C 346.859375 260.921875 346.859375 261.199219 346.859375 261.480469 C 346.582031 261.761719 346.582031 261.761719 346.300781 261.761719 L 322.175781 261.761719 C 320.492188 261.761719 318.8125 262.601562 317.6875 264.003906 C 316.566406 265.40625 316.285156 267.367188 316.847656 269.050781 L 323.578125 288.675781 L 310.675781 293.164062 C 308.992188 293.722656 307.589844 295.125 307.03125 296.808594 C 306.46875 298.492188 306.75 300.453125 307.871094 301.855469 L 316.285156 313.351562 L 308.992188 318.957031 C 307.589844 320.078125 306.75 321.761719 306.75 323.445312 L 306.75 337.742188 C 306.75 344.191406 303.382812 350.359375 297.773438 353.445312 C 295.25 355.125 292.164062 355.96875 289.078125 355.96875 C 265.796875 356.246094 176.039062 326.808594 176.039062 277.742188 L 176.039062 265.96875 C 176.039062 262.882812 173.515625 260.359375 170.429688 260.359375 C 167.34375 260.359375 164.820312 262.882812 164.820312 265.96875 L 164.820312 277.742188 C 164.820312 337.460938 265.515625 367.460938 289.359375 367.460938 C 294.40625 367.460938 299.457031 366.058594 303.664062 363.535156 C 312.640625 358.210938 317.96875 348.675781 317.96875 338.023438 L 317.96875 326.246094 L 327.226562 318.957031 C 329.46875 316.996094 330.03125 313.628906 328.347656 311.386719 L 321.335938 301.574219 L 332.554688 297.648438 C 335.359375 296.527344 337.042969 293.445312 335.921875 290.640625 L 330.03125 272.976562 L 346.300781 272.976562 C 350.226562 272.976562 353.871094 271.015625 356.117188 267.929688 C 358.359375 264.566406 358.921875 260.359375 357.519531 256.714844 L 333.675781 193.070312 L 340.410156 178.210938 C 340.691406 177.367188 340.96875 176.808594 340.96875 175.96875 L 340.96875 145.125 C 339.289062 102.789062 321.894531 67.183594 291.042969 41.949219 C 262.992188 18.957031 226.808594 7.460938 188.378906 8.582031 C 188.101562 8.582031 187.539062 8.582031 187.257812 8.582031 L 164.820312 8.582031 C 161.734375 8.582031 159.210938 11.105469 159.210938 14.191406 L 159.210938 59.050781 C 159.210938 60.453125 159.769531 61.855469 160.890625 62.976562 Z M 243.359375 50.640625 C 248.125 50.640625 251.773438 54.285156 251.773438 59.050781 C 251.773438 63.816406 248.125 67.460938 243.359375 67.460938 C 238.589844 67.460938 234.941406 63.816406 234.941406 59.050781 C 234.941406 54.285156 238.589844 50.640625 243.359375 50.640625 Z M 240.554688 117.929688 C 245.320312 117.929688 248.96875 121.574219 248.96875 126.339844 C 248.96875 131.105469 245.320312 134.753906 240.554688 134.753906 C 235.785156 134.753906 232.136719 131.105469 232.136719 126.339844 C 232.136719 121.574219 235.785156 117.929688 240.554688 117.929688 Z M 142.378906 314.191406 C 142.378906 318.957031 138.734375 322.601562 133.964844 322.601562 C 129.195312 322.601562 125.550781 318.957031 125.550781 314.191406 C 125.550781 309.425781 129.195312 305.78125 133.964844 305.78125 C 138.734375 305.78125 142.378906 309.425781 142.378906 314.191406 Z M 268.601562 92.695312 C 268.601562 87.929688 272.25 84.285156 277.015625 84.285156 C 281.785156 84.285156 285.433594 87.929688 285.433594 92.695312 C 285.433594 97.460938 281.785156 101.105469 277.015625 101.105469 C 272.25 101.105469 268.601562 97.460938 268.601562 92.695312 Z M 329.46875 140.359375 L 299.457031 140.359375 C 296.371094 140.359375 293.847656 142.882812 293.847656 145.96875 L 293.847656 169.796875 L 279.261719 199.238281 L 234.941406 199.238281 L 234.941406 174.003906 L 277.015625 174.003906 C 280.101562 174.003906 282.628906 171.480469 282.628906 168.398438 L 282.628906 111.480469 C 289.078125 109.519531 293.847656 104.472656 295.808594 98.304688 L 319.933594 98.304688 C 324.980469 110.921875 328.347656 124.9375 329.46875 140.359375 Z M 329.46875 140.359375 "
          fillOpacity="1"
          fillRule="nonzero"
        />
      </g>
      <path
        d="M 32.984375 46.996094 L 32.984375 95.5 C 32.984375 97.183594 33.828125 98.863281 34.949219 99.984375 L 65.804688 124.660156 C 66.085938 124.9375 66.363281 124.9375 66.644531 125.21875 L 66.644531 185.21875 C 66.644531 186.621094 67.207031 187.742188 68.046875 188.863281 L 83.476562 206.808594 L 83.476562 253.351562 C 75.339844 255.875 69.449219 263.164062 69.449219 272.136719 C 69.449219 283.070312 78.144531 291.761719 89.085938 291.761719 C 100.023438 291.761719 108.71875 283.070312 108.71875 272.136719 C 108.71875 263.164062 102.828125 255.875 94.695312 253.351562 L 94.695312 204.84375 C 94.695312 203.445312 94.132812 202.320312 93.292969 201.199219 L 77.867188 183.257812 L 77.867188 60.171875 L 105.914062 76.152344 L 105.914062 87.648438 C 97.78125 90.171875 91.890625 97.460938 91.890625 106.433594 C 91.890625 117.367188 100.585938 126.058594 111.523438 126.058594 C 122.464844 126.058594 131.160156 117.367188 131.160156 106.433594 C 131.160156 97.460938 125.269531 90.171875 117.132812 87.648438 L 117.132812 73.070312 C 117.132812 71.105469 116.011719 69.144531 114.328125 68.304688 L 75.058594 45.875 C 73.378906 44.753906 71.132812 44.753906 69.449219 45.875 C 67.765625 46.996094 66.644531 48.675781 66.644531 50.640625 L 66.644531 110.921875 L 44.207031 92.695312 L 44.207031 46.996094 C 52.339844 44.472656 58.230469 37.183594 58.230469 28.210938 C 58.230469 17.277344 49.535156 8.582031 38.597656 8.582031 C 27.65625 8.582031 18.960938 17.277344 18.960938 28.210938 C 18.960938 37.183594 24.851562 44.472656 32.984375 46.996094 Z M 97.5 272.136719 C 97.5 276.902344 93.855469 280.546875 89.085938 280.546875 C 84.316406 280.546875 80.671875 276.902344 80.671875 272.136719 C 80.671875 267.367188 84.316406 263.722656 89.085938 263.722656 C 93.855469 263.722656 97.5 267.367188 97.5 272.136719 Z M 119.941406 106.714844 C 119.941406 111.480469 116.292969 115.125 111.523438 115.125 C 106.757812 115.125 103.109375 111.480469 103.109375 106.714844 C 103.109375 101.949219 106.757812 98.304688 111.523438 98.304688 C 116.292969 98.304688 119.941406 101.949219 119.941406 106.714844 Z M 38.597656 19.796875 C 43.363281 19.796875 47.011719 23.445312 47.011719 28.210938 C 47.011719 32.976562 43.363281 36.621094 38.597656 36.621094 C 33.828125 36.621094 30.179688 32.976562 30.179688 28.210938 C 30.179688 23.445312 33.828125 19.796875 38.597656 19.796875 Z M 38.597656 19.796875 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        d="M 159.210938 97.742188 L 159.210938 179.890625 L 117.132812 221.949219 L 117.132812 181.574219 C 125.269531 179.050781 131.160156 171.761719 131.160156 162.789062 C 131.160156 151.855469 122.464844 143.164062 111.523438 143.164062 C 100.585938 143.164062 91.890625 151.855469 91.890625 162.789062 C 91.890625 171.761719 97.78125 179.050781 105.914062 181.574219 L 105.914062 235.6875 C 105.914062 237.929688 107.316406 239.890625 109.28125 240.734375 C 110.121094 241.292969 110.683594 241.292969 111.523438 241.292969 C 112.925781 241.292969 114.328125 240.734375 115.453125 239.613281 L 168.746094 186.339844 C 169.867188 185.21875 170.429688 183.816406 170.429688 182.414062 L 170.429688 95.5 C 170.429688 94.097656 169.867188 92.695312 168.746094 91.574219 L 147.988281 70.828125 L 147.988281 28.210938 C 147.988281 25.125 145.464844 22.601562 142.378906 22.601562 C 139.292969 22.601562 136.769531 25.125 136.769531 28.210938 L 136.769531 73.070312 C 136.769531 74.472656 137.332031 75.875 138.453125 76.996094 Z M 111.523438 171.199219 C 106.757812 171.199219 103.109375 167.554688 103.109375 162.789062 C 103.109375 158.023438 106.757812 154.378906 111.523438 154.378906 C 116.292969 154.378906 119.941406 158.023438 119.941406 162.789062 C 119.941406 167.554688 116.292969 171.199219 111.523438 171.199219 Z M 111.523438 171.199219 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        d="M 16.15625 232.882812 C 16.15625 243.816406 24.851562 252.507812 35.789062 252.507812 C 46.730469 252.507812 55.425781 243.816406 55.425781 232.882812 C 55.425781 223.910156 49.535156 216.621094 41.402344 214.097656 L 41.402344 175.96875 C 49.535156 173.445312 55.425781 166.152344 55.425781 157.183594 C 55.425781 146.246094 46.730469 137.554688 35.789062 137.554688 C 24.851562 137.554688 16.15625 146.246094 16.15625 157.183594 C 16.15625 166.152344 22.046875 173.445312 30.179688 175.96875 L 30.179688 214.097656 C 22.046875 216.621094 16.15625 223.910156 16.15625 232.882812 Z M 27.375 157.183594 C 27.375 152.414062 31.023438 148.769531 35.789062 148.769531 C 40.558594 148.769531 44.207031 152.414062 44.207031 157.183594 C 44.207031 161.949219 40.558594 165.59375 35.789062 165.59375 C 31.023438 165.59375 27.375 161.949219 27.375 157.183594 Z M 35.789062 224.472656 C 40.558594 224.472656 44.207031 228.117188 44.207031 232.882812 C 44.207031 237.648438 40.558594 241.292969 35.789062 241.292969 C 31.023438 241.292969 27.375 237.648438 27.375 232.882812 C 27.375 228.117188 31.023438 224.472656 35.789062 224.472656 Z M 35.789062 224.472656 "
        fillOpacity="1"
        fillRule="nonzero"
      />
    </svg>
  ),
  close: X,
  spinner: Loader2,
  chevronLeft: ChevronLeft,
  chevronRight: ChevronRight,
  chevronDown: ChevronDown,
  chevronUp: ChevronUp,
  chevronLeftCircle: ChevronLeftCircle,
  chevronRightCircle: ChevronRightCircle,
  chevronUpCircle: ChevronUpCircle,
  chevronDownCircle: ChevronDownCircle,
  trash: Trash,
  post: FileText,
  page: File,
  media: Image,
  settings: Settings,
  billing: CreditCard,
  ellipsis: MoreVertical,
  add: Plus,
  warning: AlertTriangle,
  user: User,
  arrowRight: ArrowRight,
  help: HelpCircle,
  pizza: Pizza,
  sun: SunMedium,
  moon: Moon,
  laptop: Laptop,
  linkedin: Linkedin,
  gitHub: ({ ...props }: LucideProps) => (
    <svg
      aria-hidden="true"
      focusable="false"
      data-prefix="fab"
      data-icon="github"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 496 512"
      {...props}
    >
      <path
        fill="currentColor"
        d="M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3 .3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5 .3-6.2 2.3zm44.2-1.7c-2.9 .7-4.9 2.6-4.6 4.9 .3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3 .7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3 .3 2.9 2.3 3.9 1.6 1 3.6 .7 4.3-.7 .7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3 .7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3 .7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"
      />
    </svg>
  ),
  twitter: Twitter,
  check: Check,
  botIcon: () => {
    return (
      <svg
        height="16"
        strokeLinejoin="round"
        viewBox="0 0 16 16"
        width="16"
        style={{ color: 'currentcolor' }}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.75 2.79933C9.19835 2.53997 9.5 2.05521 9.5 1.5C9.5 0.671573 8.82843 0 8 0C7.17157 0 6.5 0.671573 6.5 1.5C6.5 2.05521 6.80165 2.53997 7.25 2.79933V5H7C4.027 5 1.55904 7.16229 1.08296 10H0V13H1V14.5V16H2.5H13.5H15V14.5V13H16V10H14.917C14.441 7.16229 11.973 5 9 5H8.75V2.79933ZM7 6.5C4.51472 6.5 2.5 8.51472 2.5 11V14.5H13.5V11C13.5 8.51472 11.4853 6.5 9 6.5H7ZM7.25 11.25C7.25 12.2165 6.4665 13 5.5 13C4.5335 13 3.75 12.2165 3.75 11.25C3.75 10.2835 4.5335 9.5 5.5 9.5C6.4665 9.5 7.25 10.2835 7.25 11.25ZM10.5 13C11.4665 13 12.25 12.2165 12.25 11.25C12.25 10.2835 11.4665 9.5 10.5 9.5C9.5335 9.5 8.75 10.2835 8.75 11.25C8.75 12.2165 9.5335 13 10.5 13Z"
          fill="currentColor"
        />
      </svg>
    )
  },
  userIcon: User,
  attachmentIcon: () => {
    return (
      <svg
        height="16"
        strokeLinejoin="round"
        viewBox="0 0 16 16"
        width="16"
        style={{ color: 'currentcolor' }}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.5 6.5V13.5C14.5 14.8807 13.3807 16 12 16H4C2.61929 16 1.5 14.8807 1.5 13.5V1.5V0H3H8H9.08579C9.351 0 9.60536 0.105357 9.79289 0.292893L14.2071 4.70711C14.3946 4.89464 14.5 5.149 14.5 5.41421V6.5ZM13 6.5V13.5C13 14.0523 12.5523 14.5 12 14.5H4C3.44772 14.5 3 14.0523 3 13.5V1.5H8V5V6.5H9.5H13ZM9.5 2.12132V5H12.3787L9.5 2.12132Z"
          fill="currentColor"
        />
      </svg>
    )
  },
  vercelIcon: ({ size = 17 }: { size?: number }) => {
    return (
      <svg
        height={size}
        strokeLinejoin="round"
        viewBox="0 0 16 16"
        width={size}
        style={{ color: 'currentcolor' }}
      >
        <path fillRule="evenodd" clipRule="evenodd" d="M8 1L16 15H0L8 1Z" fill="currentColor" />
      </svg>
    )
  },
  boxIcon: Box,
  homeIcon: Home,
  gpsIcon: MapPin,
  invoiceIcon: FileText,
  logoOpenAI: ({ size = 16 }: { size?: number }) => {
    return (
      <svg
        height={size}
        strokeLinejoin="round"
        viewBox="0 0 16 16"
        width={size}
        style={{ color: 'currentcolor' }}
      >
        <path
          d="M14.9449 6.54871C15.3128 5.45919 15.1861 4.26567 14.5978 3.27464C13.7131 1.75461 11.9345 0.972595 10.1974 1.3406C9.42464 0.481584 8.3144 -0.00692594 7.15045 7.42132e-05C5.37487 -0.00392587 3.79946 1.1241 3.2532 2.79113C2.11256 3.02164 1.12799 3.72615 0.551837 4.72468C-0.339497 6.24071 -0.1363 8.15175 1.05451 9.45178C0.686626 10.5413 0.813308 11.7348 1.40162 12.7258C2.28637 14.2459 4.06498 15.0279 5.80204 14.6599C6.5743 15.5189 7.68504 16.0074 8.849 15.9999C10.6256 16.0044 12.2015 14.8754 12.7478 13.2069C13.8884 12.9764 14.873 12.2718 15.4491 11.2733C16.3394 9.75728 16.1357 7.84774 14.9454 6.54771L14.9449 6.54871ZM8.85001 14.9544C8.13907 14.9554 7.45043 14.7099 6.90468 14.2604C6.92951 14.2474 6.97259 14.2239 7.00046 14.2069L10.2293 12.3668C10.3945 12.2743 10.4959 12.1008 10.4949 11.9133V7.42173L11.8595 8.19925C11.8742 8.20625 11.8838 8.22025 11.8858 8.23625V11.9558C11.8838 13.6099 10.5263 14.9509 8.85001 14.9544ZM2.32133 12.2028C1.9651 11.5958 1.8369 10.8843 1.95902 10.1938C1.98284 10.2078 2.02489 10.2333 2.05479 10.2503L5.28366 12.0903C5.44733 12.1848 5.65003 12.1848 5.81421 12.0903L9.75604 9.84429V11.3993C9.75705 11.4153 9.74945 11.4308 9.73678 11.4408L6.47295 13.3004C5.01915 14.1264 3.1625 13.6354 2.32184 12.2028H2.32133ZM1.47155 5.24819C1.82626 4.64017 2.38619 4.17516 3.05305 3.93366C3.05305 3.96116 3.05152 4.00966 3.05152 4.04366V7.72424C3.05051 7.91124 3.15186 8.08475 3.31654 8.17725L7.25838 10.4228L5.89376 11.2003C5.88008 11.2093 5.86285 11.2108 5.84765 11.2043L2.58331 9.34327C1.13255 8.51426 0.63494 6.68272 1.47104 5.24869L1.47155 5.24819ZM12.6834 7.82274L8.74157 5.57669L10.1062 4.79968C10.1199 4.79068 10.1371 4.78918 10.1523 4.79568L13.4166 6.65522C14.8699 7.48373 15.3681 9.31827 14.5284 10.7523C14.1732 11.3593 13.6138 11.8243 12.9474 12.0663V8.27575C12.9489 8.08875 12.8481 7.91574 12.6839 7.82274H12.6834ZM14.0414 5.8057C14.0176 5.7912 13.9756 5.7662 13.9457 5.7492L10.7168 3.90916C10.5531 3.81466 10.3504 3.81466 10.1863 3.90916L6.24442 6.15521V4.60017C6.2434 4.58417 6.251 4.56867 6.26367 4.55867L9.52751 2.70063C10.9813 1.87311 12.84 2.36563 13.6781 3.80066C14.0323 4.40667 14.1605 5.11618 14.0404 5.8057H14.0414ZM5.50257 8.57726L4.13744 7.79974C4.12275 7.79274 4.11312 7.77874 4.11109 7.76274V4.04316C4.11211 2.38713 5.47368 1.0451 7.15197 1.0461C7.86189 1.0461 8.54902 1.2921 9.09476 1.74011C9.06993 1.75311 9.02737 1.77661 8.99899 1.79361L5.77012 3.63365C5.60493 3.72615 5.50358 3.89916 5.50459 4.08666L5.50257 8.57626V8.57726ZM6.24391 7.00022L7.99972 5.9997L9.75553 6.99972V9.00027L7.99972 10.0003L6.24391 9.00027V7.00022Z"
          fill="currentColor"
        />
      </svg>
    )
  },
  logoGoogle: ({ size = 16 }: { size?: number }) => {
    return (
      <svg
        data-testid="geist-icon"
        height={size}
        strokeLinejoin="round"
        viewBox="0 0 16 16"
        width={size}
        style={{ color: 'currentcolor' }}
      >
        <path
          d="M8.15991 6.54543V9.64362H12.4654C12.2763 10.64 11.709 11.4837 10.8581 12.0509L13.4544 14.0655C14.9671 12.6692 15.8399 10.6182 15.8399 8.18188C15.8399 7.61461 15.789 7.06911 15.6944 6.54552L8.15991 6.54543Z"
          fill="#4285F4"
        />
        <path
          d="M3.6764 9.52268L3.09083 9.97093L1.01807 11.5855C2.33443 14.1963 5.03241 16 8.15966 16C10.3196 16 12.1305 15.2873 13.4542 14.0655L10.8578 12.0509C10.1451 12.5309 9.23598 12.8219 8.15966 12.8219C6.07967 12.8219 4.31245 11.4182 3.67967 9.5273L3.6764 9.52268Z"
          fill="#34A853"
        />
        <path
          d="M1.01803 4.41455C0.472607 5.49087 0.159912 6.70543 0.159912 7.99995C0.159912 9.29447 0.472607 10.509 1.01803 11.5854C1.01803 11.5926 3.6799 9.51991 3.6799 9.51991C3.5199 9.03991 3.42532 8.53085 3.42532 7.99987C3.42532 7.46889 3.5199 6.95983 3.6799 6.47983L1.01803 4.41455Z"
          fill="#FBBC05"
        />
        <path
          d="M8.15982 3.18545C9.33802 3.18545 10.3853 3.59271 11.2216 4.37818L13.5125 2.0873C12.1234 0.792777 10.3199 0 8.15982 0C5.03257 0 2.33443 1.79636 1.01807 4.41455L3.67985 6.48001C4.31254 4.58908 6.07983 3.18545 8.15982 3.18545Z"
          fill="#EA4335"
        />
      </svg>
    )
  },
  logoAnthropic: () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 92.2 65"
        style={{ color: 'currentcolor', fill: 'currentcolor' }}
        width="18px"
        height="18px"
      >
        <path
          d="M66.5,0H52.4l25.7,65h14.1L66.5,0z M25.7,0L0,65h14.4l5.3-13.6h26.9L51.8,65h14.4L40.5,0C40.5,0,25.7,0,25.7,0z
      M24.3,39.3l8.8-22.8l8.8,22.8H24.3z"
        />
      </svg>
    )
  },
  routeIcon: ({ size = 16 }: { size?: number }) => {
    return (
      <svg
        height={size}
        strokeLinejoin="round"
        viewBox="0 0 16 16"
        width={size}
        style={{ color: 'currentcolor' }}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.53033 0.719661L7 0.189331L5.93934 1.24999L6.46967 1.78032L6.68934 1.99999H3.375C1.51104 1.99999 0 3.51103 0 5.37499C0 7.23895 1.51104 8.74999 3.375 8.74999H12.625C13.6605 8.74999 14.5 9.58946 14.5 10.625C14.5 11.6605 13.6605 12.5 12.625 12.5H4.88555C4.56698 11.4857 3.61941 10.75 2.5 10.75C1.11929 10.75 0 11.8693 0 13.25C0 14.6307 1.11929 15.75 2.5 15.75C3.61941 15.75 4.56698 15.0143 4.88555 14H12.625C14.489 14 16 12.489 16 10.625C16 8.76103 14.489 7.24999 12.625 7.24999H3.375C2.33947 7.24999 1.5 6.41052 1.5 5.37499C1.5 4.33946 2.33947 3.49999 3.375 3.49999H6.68934L6.46967 3.71966L5.93934 4.24999L7 5.31065L7.53033 4.78032L8.85355 3.4571C9.24408 3.06657 9.24408 2.43341 8.85355 2.04288L7.53033 0.719661ZM2.5 14.25C3.05228 14.25 3.5 13.8023 3.5 13.25C3.5 12.6977 3.05228 12.25 2.5 12.25C1.94772 12.25 1.5 12.6977 1.5 13.25C1.5 13.8023 1.94772 14.25 2.5 14.25ZM14.5 2.74999C14.5 3.30228 14.0523 3.74999 13.5 3.74999C12.9477 3.74999 12.5 3.30228 12.5 2.74999C12.5 2.19771 12.9477 1.74999 13.5 1.74999C14.0523 1.74999 14.5 2.19771 14.5 2.74999ZM16 2.74999C16 4.1307 14.8807 5.24999 13.5 5.24999C12.1193 5.24999 11 4.1307 11 2.74999C11 1.36928 12.1193 0.249991 13.5 0.249991C14.8807 0.249991 16 1.36928 16 2.74999Z"
          fill="currentColor"
        />
      </svg>
    )
  },
  fileIcon: File,
  loaderIcon: ({ size = 16 }: { size?: number }) => {
    return (
      <svg
        height={size}
        strokeLinejoin="round"
        viewBox="0 0 16 16"
        width={size}
        style={{ color: 'currentcolor' }}
      >
        <g clipPath="url(#clip0_2393_1490)">
          <path d="M8 0V4" stroke="currentColor" strokeWidth="1.5" />
          <path opacity="0.5" d="M8 16V12" stroke="currentColor" strokeWidth="1.5" />
          <path
            opacity="0.9"
            d="M3.29773 1.52783L5.64887 4.7639"
            stroke="currentColor"
            strokeWidth="1.5"
          />
          <path
            opacity="0.1"
            d="M12.7023 1.52783L10.3511 4.7639"
            stroke="currentColor"
            strokeWidth="1.5"
          />
          <path
            opacity="0.4"
            d="M12.7023 14.472L10.3511 11.236"
            stroke="currentColor"
            strokeWidth="1.5"
          />
          <path
            opacity="0.6"
            d="M3.29773 14.472L5.64887 11.236"
            stroke="currentColor"
            strokeWidth="1.5"
          />
          <path
            opacity="0.2"
            d="M15.6085 5.52783L11.8043 6.7639"
            stroke="currentColor"
            strokeWidth="1.5"
          />
          <path
            opacity="0.7"
            d="M0.391602 10.472L4.19583 9.23598"
            stroke="currentColor"
            strokeWidth="1.5"
          />
          <path
            opacity="0.3"
            d="M15.6085 10.4722L11.8043 9.2361"
            stroke="currentColor"
            strokeWidth="1.5"
          />
          <path
            opacity="0.8"
            d="M0.391602 5.52783L4.19583 6.7639"
            stroke="currentColor"
            strokeWidth="1.5"
          />
        </g>
        <defs>
          <clipPath id="clip0_2393_1490">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    )
  },
  uploadIcon: Upload,
  menuIcon: Menu,
  pencilEditIcon: Pencil,
  checkedSquareIcon: ({ size = 16 }: { size?: number }) => {
    return (
      <svg
        height={size}
        strokeLinejoin="round"
        viewBox="0 0 16 16"
        width={size}
        style={{ color: 'currentcolor' }}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15 16H1C0.447715 16 0 15.5523 0 15V1C0 0.447715 0.447716 0 1 0L15 8.17435e-06C15.5523 8.47532e-06 16 0.447724 16 1.00001V15C16 15.5523 15.5523 16 15 16ZM11.7803 6.28033L12.3107 5.75L11.25 4.68934L10.7197 5.21967L6.5 9.43935L5.28033 8.21967L4.75001 7.68934L3.68934 8.74999L4.21967 9.28033L5.96967 11.0303C6.11032 11.171 6.30109 11.25 6.5 11.25C6.69891 11.25 6.88968 11.171 7.03033 11.0303L11.7803 6.28033Z"
          fill="currentColor"
        />
      </svg>
    )
  },
  uncheckedSquareIcon: ({ size = 16 }: { size?: number }) => {
    return (
      <svg
        height={size}
        strokeLinejoin="round"
        viewBox="0 0 16 16"
        width={size}
        style={{ color: 'currentcolor' }}
      >
        <rect
          x="1"
          y="1"
          width="14"
          height="14"
          stroke="currentColor"
          strokeWidth="1.5"
          fill="none"
        />
      </svg>
    )
  },
  checkCircleFillIcon: ({ size = 16 }: { size?: number }) => {
    return (
      <svg
        height={size}
        strokeLinejoin="round"
        viewBox="0 0 16 16"
        width={size}
        style={{ color: 'currentcolor' }}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM11.5303 6.53033L12.0607 6L11 4.93934L10.4697 5.46967L6.5 9.43934L5.53033 8.46967L5 7.93934L3.93934 9L4.46967 9.53033L5.96967 11.0303C6.26256 11.3232 6.73744 11.3232 7.03033 11.0303L11.5303 6.53033Z"
          fill="currentColor"
        />
      </svg>
    )
  },
  copyIcon: Copy,
  thumbUpIcon: ThumbsUp,
  thumbDownIcon: ThumbsDown,
  clockRewindIcon: ({ size = 16 }: { size?: number }) => {
    return (
      <svg
        height={size}
        strokeLinejoin="round"
        viewBox="0 0 16 16"
        width={size}
        style={{ color: 'currentcolor' }}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.96452 2.5C11.0257 2.5 13.5 4.96643 13.5 8C13.5 11.0336 11.0257 13.5 7.96452 13.5C6.12055 13.5 4.48831 12.6051 3.48161 11.2273L3.03915 10.6217L1.828 11.5066L2.27046 12.1122C3.54872 13.8617 5.62368 15 7.96452 15C11.8461 15 15 11.87 15 8C15 4.13001 11.8461 1 7.96452 1C5.06835 1 2.57851 2.74164 1.5 5.23347V3.75V3H0V3.75V7.25C0 7.66421 0.335786 8 0.75 8H3.75H4.5V6.5H3.75H2.63724C3.29365 4.19393 5.42843 2.5 7.96452 2.5ZM8.75 5.25V4.5H7.25V5.25V7.8662C7.25 8.20056 7.4171 8.51279 7.6953 8.69825L9.08397 9.62404L9.70801 10.0401L10.5401 8.79199L9.91603 8.37596L8.75 7.59861V5.25Z"
          fill="currentColor"
        />
      </svg>
    )
  },
  undoIcon: Undo,
  redoIcon: Redo,
  playIcon: Play,
  crossIcon: ({ size = 16 }: { size?: number }) => (
    <svg
      height={size}
      strokeLinejoin="round"
      viewBox="0 0 16 16"
      width={size}
      style={{ color: 'currentcolor' }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.4697 13.5303L13 14.0607L14.0607 13L13.5303 12.4697L9.06065 7.99999L13.5303 3.53032L14.0607 2.99999L13 1.93933L12.4697 2.46966L7.99999 6.93933L3.53032 2.46966L2.99999 1.93933L1.93933 2.99999L2.46966 3.53032L6.93933 7.99999L2.46966 12.4697L1.93933 13L2.99999 14.0607L3.53032 13.5303L7.99999 9.06065L12.4697 13.5303Z"
        fill="currentColor"
      />
    </svg>
  ),
  terminalWindowIcon: ({ size = 16 }: { size?: number }) => {
    return (
      <svg
        height={size}
        strokeLinejoin="round"
        viewBox="0 0 16 16"
        width={size}
        style={{ color: 'currentcolor' }}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.5 2.5H14.5V12.5C14.5 13.0523 14.0523 13.5 13.5 13.5H2.5C1.94772 13.5 1.5 13.0523 1.5 12.5V2.5ZM0 1H1.5H14.5H16V2.5V12.5C16 13.8807 14.8807 15 13.5 15H2.5C1.11929 15 0 13.8807 0 12.5V2.5V1ZM4 11.1339L4.44194 10.6919L6.51516 8.61872C6.85687 8.27701 6.85687 7.72299 6.51517 7.38128L4.44194 5.30806L4 4.86612L3.11612 5.75L3.55806 6.19194L5.36612 8L3.55806 9.80806L3.11612 10.25L4 11.1339ZM8 9.75494H8.6225H11.75H12.3725V10.9999H11.75H8.6225H8V9.75494Z"
          fill="currentColor"
        />
      </svg>
    )
  },
  crossSmallIcon: ({ size = 16 }: { size?: number }) => (
    <svg
      height={size}
      strokeLinejoin="round"
      viewBox="0 0 16 16"
      width={size}
      style={{ color: 'currentcolor' }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.96966 11.0303L10.5 11.5607L11.5607 10.5L11.0303 9.96966L9.06065 7.99999L11.0303 6.03032L11.5607 5.49999L10.5 4.43933L9.96966 4.96966L7.99999 6.93933L6.03032 4.96966L5.49999 4.43933L4.43933 5.49999L4.96966 6.03032L6.93933 7.99999L4.96966 9.96966L4.43933 10.5L5.49999 11.5607L6.03032 11.0303L7.99999 9.06065L9.96966 11.0303Z"
        fill="currentColor"
      />
    </svg>
  ),
  fullscreenIcon: Fullscreen,
  messageIcon: ({ size = 16 }: { size?: number }) => {
    return (
      <svg
        height={size}
        strokeLinejoin="round"
        viewBox="0 0 16 16"
        width={size}
        style={{ color: 'currentcolor' }}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.8914 10.4028L2.98327 10.6318C3.22909 11.2445 3.5 12.1045 3.5 13C3.5 13.3588 3.4564 13.7131 3.38773 14.0495C3.69637 13.9446 4.01409 13.8159 4.32918 13.6584C4.87888 13.3835 5.33961 13.0611 5.70994 12.7521L6.22471 12.3226L6.88809 12.4196C7.24851 12.4724 7.61994 12.5 8 12.5C11.7843 12.5 14.5 9.85569 14.5 7C14.5 4.14431 11.7843 1.5 8 1.5C4.21574 1.5 1.5 4.14431 1.5 7C1.5 8.18175 1.94229 9.29322 2.73103 10.2153L2.8914 10.4028ZM2.8135 15.7653C1.76096 16 1 16 1 16C1 16 1.43322 15.3097 1.72937 14.4367C1.88317 13.9834 2 13.4808 2 13C2 12.3826 1.80733 11.7292 1.59114 11.1903C0.591845 10.0221 0 8.57152 0 7C0 3.13401 3.58172 0 8 0C12.4183 0 16 3.13401 16 7C16 10.866 12.4183 14 8 14C7.54721 14 7.10321 13.9671 6.67094 13.9038C6.22579 14.2753 5.66881 14.6656 5 15C4.23366 15.3832 3.46733 15.6195 2.8135 15.7653Z"
          fill="currentColor"
        />
      </svg>
    )
  },
  arrowUpIcon: ArrowUp,
  summarizeIcon: ({ size = 16 }: { size?: number }) => (
    <svg
      height={size}
      strokeLinejoin="round"
      viewBox="0 0 16 16"
      width={size}
      style={{ color: 'currentcolor' }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.75 12H1V10.5H1.75H5.25H6V12H5.25H1.75ZM1.75 7.75H1V6.25H1.75H4.25H5V7.75H4.25H1.75ZM1.75 3.5H1V2H1.75H7.25H8V3.5H7.25H1.75ZM12.5303 14.7803C12.2374 15.0732 11.7626 15.0732 11.4697 14.7803L9.21967 12.5303L8.68934 12L9.75 10.9393L10.2803 11.4697L11.25 12.4393V2.75V2H12.75V2.75V12.4393L13.7197 11.4697L14.25 10.9393L15.3107 12L14.7803 12.5303L12.5303 14.7803Z"
        fill="currentColor"
      />
    </svg>
  ),
  penIcon: Pen,
  codeIcon: ({ size = 16 }: { size?: number }) => {
    return (
      <svg
        height={size}
        strokeLinejoin="round"
        viewBox="0 0 16 16"
        width={size}
        style={{ color: 'currentcolor' }}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.21969 12.5303L4.75002 13.0607L5.81068 12L5.28035 11.4697L1.81068 7.99999L5.28035 4.53032L5.81068 3.99999L4.75002 2.93933L4.21969 3.46966L0.39647 7.29289C0.00594562 7.68341 0.00594562 8.31658 0.39647 8.7071L4.21969 12.5303ZM11.7804 12.5303L11.25 13.0607L10.1894 12L10.7197 11.4697L14.1894 7.99999L10.7197 4.53032L10.1894 3.99999L11.25 2.93933L11.7804 3.46966L15.6036 7.29289C15.9941 7.68341 15.9941 8.31658 15.6036 8.7071L11.7804 12.5303Z"
          fill="currentColor"
        />
      </svg>
    )
  },
  logsIcon: ({ size = 16 }: { size?: number }) => {
    return (
      <svg
        height={size}
        strokeLinejoin="round"
        viewBox="0 0 16 16"
        width={size}
        style={{ color: 'currentcolor' }}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9 2H9.75H14.25H15V3.5H14.25H9.75H9V2ZM9 12.5H9.75H14.25H15V14H14.25H9.75H9V12.5ZM9.75 7.25H9V8.75H9.75H14.25H15V7.25H14.25H9.75ZM1 12.5H1.75H2.25H3V14H2.25H1.75H1V12.5ZM1.75 2H1V3.5H1.75H2.25H3V2H2.25H1.75ZM1 7.25H1.75H2.25H3V8.75H2.25H1.75H1V7.25ZM5.75 12.5H5V14H5.75H6.25H7V12.5H6.25H5.75ZM5 2H5.75H6.25H7V3.5H6.25H5.75H5V2ZM5.75 7.25H5V8.75H5.75H6.25H7V7.25H6.25H5.75Z"
          fill="currentColor"
        />
      </svg>
    )
  },
  stopIcon: ({ size = 16 }: { size?: number }) => {
    return (
      <svg height={size} viewBox="0 0 16 16" width={size} style={{ color: 'currentcolor' }}>
        <path fillRule="evenodd" clipRule="evenodd" d="M3 3H13V13H3V3Z" fill="currentColor" />
      </svg>
    )
  },
  paperclipIcon: Paperclip,
  lockIcon: ({ size = 16 }: { size?: number }) => {
    return (
      <svg
        height={size}
        strokeLinejoin="round"
        viewBox="0 0 16 16"
        width={size}
        style={{ color: 'currentcolor' }}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10 4.5V6H6V4.5C6 3.39543 6.89543 2.5 8 2.5C9.10457 2.5 10 3.39543 10 4.5ZM4.5 6V4.5C4.5 2.567 6.067 1 8 1C9.933 1 11.5 2.567 11.5 4.5V6H12.5H14V7.5V12.5C14 13.8807 12.8807 15 11.5 15H4.5C3.11929 15 2 13.8807 2 12.5V7.5V6H3.5H4.5ZM11.5 7.5H10H6H4.5H3.5V12.5C3.5 13.0523 3.94772 13.5 4.5 13.5H11.5C12.0523 13.5 12.5 13.0523 12.5 12.5V7.5H11.5Z"
          fill="currentColor"
        />
      </svg>
    )
  },
  globeIcon: Globe,
}
